import {
  BookingQuestionValue,
  ExternalBookingQuestion,
  Subquestion,
} from "../../../AppDataProvider/types";

import { BookingQuestionFieldType } from "../../../GeneratedGraphQL";
import { getCheckboxInput } from "./getCheckboxInput/getCheckboxInput";
import { getDropdownInput } from "./getDropdownInput/getDropdownInput";
import { getFileInput } from "./getFileInput/getFileInput";
import { getTermsInput } from "./getTermsInput/getTermsInput";
import { getTextInput } from "./getTextInput/getTextInput";
import { OnChangeBookingQuestionValueFunction } from "../BookingQuestionsStep";

export type GetInputOptions = {
  error?: string;
  fileName?: string;
  onChange: OnChangeBookingQuestionValueFunction;
  onStartUpload?: () => void;
  onStopUpload?: () => void;
  question: ExternalBookingQuestion | Subquestion;
  setError?: (error: string) => void;
  value?: BookingQuestionValue;
};

const inputMap: Record<
  BookingQuestionFieldType,
  (options: GetInputOptions) => React.ReactNode
> = {
  [BookingQuestionFieldType.Checkbox]: getCheckboxInput,
  [BookingQuestionFieldType.Dropdown]: getDropdownInput,
  [BookingQuestionFieldType.File]: getFileInput,
  [BookingQuestionFieldType.Terms]: getTermsInput,
  [BookingQuestionFieldType.Text]: getTextInput,
};

export const getInput = ({
  error,
  fileName,
  onChange,
  question,
  setError,
  onStartUpload,
  onStopUpload,
  value,
}: GetInputOptions): React.ReactNode => {
  const { type } = question;
  return inputMap[type]({
    error,
    fileName,
    onChange,
    onStartUpload,
    onStopUpload,
    question,
    setError,
    value,
  });
};
